export function trimSerialNumber(string: string | undefined): string {
  return (string ?? '').replace(/^0+/, '');
}
